var kosan = kosan || {};

kosan.searchNav = new function () {
    var self = this;

    this.init = function(){
        self.scrollOnSearch();
        
    };

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    this.scrollOnSearch = function (callback) {
        var searchTerm = getParameterByName('searchterm');

        if (searchTerm != null) {
            $('*[nc-search-key]').each(function () {

                var result = $(this);
                var string = $(result).text().toLowerCase();

                if (string.search(searchTerm.toLowerCase()) != -1) {
                    $(result).addClass('search-result');
                }
            });

            var firstResult = $('.search-result').first();

            $('html, body').animate({
                scrollTop: $(firstResult).offset().top - 250
            }, 1000);
        }
    };
}